// Video section — play/pause toggle

function initVsVideo() {
  const wrap = document.querySelector(".vs-video-wrap");
  if (!wrap) return;

  const video = wrap.querySelector(".vs-video");
  const btn = wrap.querySelector(".vs-play-btn");
  if (!video || !btn) return;

  btn.addEventListener("click", () => {
    video.play();
    wrap.classList.add("is-playing");
  });

  video.addEventListener("click", () => {
    if (video.paused) {
      video.play();
      wrap.classList.add("is-playing");
    } else {
      video.pause();
      wrap.classList.remove("is-playing");
    }
  });

  video.addEventListener("ended", () => {
    wrap.classList.remove("is-playing");
  });
}

document.addEventListener("turbo:load", initVsVideo);
if (document.readyState !== "loading") initVsVideo();
